import { ReimbursementReport } from "~/providers/components";

export const OngoingPatientProgressNote = () => {
  return <ReimbursementReport />;
};
